import React, { useEffect, useState } from "react";
import { sortByDateInReverse } from "../../../Utils";

import { Box, Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import moment from "moment";

const classes = {
    cardLink: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "1rem",
        alignItems: "center",
        fontSize: ".7rem",
        padding: "6px 8px",
    },
    cardLinkButton: {
        fontSize: ".7rem",
        position: "relative",
        right: "-8px",
    },
};

const theme = createTheme({
    overrides: {
        MuiTableCell: {
            root: {
                padding: "4px 8px !important",
            },
        },
    },
});

export default function EdgeDeviceRecentCallList({ deviceId, d, itemType, showCalls, deviceType }) {
    const [showRecentCalls, setShowRecentCalls] = useState(false);
    const [lastCall, setLastCall] = useState("");
    const [messages, setMessages] = useState(null);
    const [minutesLastCall, setMinutesLastCall] = useState("");
    const [showPoints] = useState(deviceType === "v3");

    const setLastCallDifference = (sortedMessages) => {
        if (sortedMessages) {
            let rtuMessages = sortedMessages;
            let recentCallDttm = rtuMessages[0].dttm;
            let callDttm = moment(recentCallDttm);
            let currentDttm = moment(new Date());
            let diff = currentDttm.diff(callDttm, "minutes");

            setMinutesLastCall(diff);
        }
    };

    useEffect(() => {
        setShowRecentCalls(showCalls);
    }, [showCalls]);

    useEffect(() => {
        if (d?.length) {
            let sortedMessages = sortByDateInReverse(d);
            let recentMessages = sortedMessages.slice(0, 10);
            let lastCallDttm = recentMessages?.[0].dttm
                ? moment(recentMessages[0].dttm).utc().format("MM/DD HH:mm")
                : "";

            setLastCall(lastCallDttm);
            setMessages(recentMessages);
        }
    }, [d, deviceId]);

    useEffect(() => {
        setLastCallDifference(messages);

        const loop = () => {
            setInterval(() => {
                setLastCallDifference(messages);
            }, 6000);
        };

        return () => {
            clearInterval(loop);
        };
    }, [messages]);

    const toggleRecentCallsList = () => {
        setShowRecentCalls(!showRecentCalls);
    };

    const calculateDateDiff = (start, end) => {
        let years = start.diff(end, "year");
        end.add(years, "years");

        let months = start.diff(end, "months");
        end.add(months, "months");

        let days = start.diff(end, "days");
        end.add(days, "days");

        let hours = start.diff(end, "hours");
        end.add(hours, "hours");
        if (hours.toString().length === 1) hours = "0" + hours;

        let minutes = start.diff(end, "minutes");
        end.add(minutes, "minutes");
        if (minutes.toString().length === 1) minutes = "0" + minutes;

        let seconds = start.diff(end, "seconds");
        end.add(seconds, "seconds");
        if (seconds.toString().length === 1) seconds = "0" + seconds;

        return { years, months, days, hours, minutes, seconds };
    };

    return <>
        {itemType !== "list" && (
            <Box component="div" sx={classes.cardLink}>
                <Box component="div" sx={classes.lastUpdate}>
                    Last Update: {lastCall} ({minutesLastCall} minutes ago)
                </Box>
                <Button sx={classes.cardLinkButton} onClick={toggleRecentCallsList} color="primary">
                    {showRecentCalls ? "Hide Recent Calls" : "Show Recent Calls"}
                </Button>
            </Box>
        )}
        {showRecentCalls ? (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <TableContainer component={Paper} style={{ marginBottom: "1rem" }}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: "50%" }} align="center">
                                        Message Dttm (GMT+0)
                                    </TableCell>
                                    <TableCell style={{ width: "30%" }} align="center">
                                        Message Age
                                    </TableCell>
                                    {showPoints && (
                                        <TableCell style={{ width: "20%" }} align="center">
                                            Points
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {messages.map((message) => {
                                    let { compressed_count, dttm, received_timestamp, edge_device_id, rtu_id } =
                                        message;
                                    let messageDttm = dttm ?? received_timestamp;
                                    let callDttm = moment(messageDttm).utc();
                                    let utcDateTime = moment(callDttm).format("MMMM DD, YYYY HH:mm:ss");
                                    let currentDttm = moment(new Date()).utc();
                                    let deviceId = edge_device_id ?? rtu_id;

                                    let { years, months, days, hours, minutes, seconds } = calculateDateDiff(
                                        currentDttm,
                                        callDttm
                                    );

                                    let callAge;

                                    if (years || months || days) {
                                        callAge = `${years} years ${months} months ${days} days \n ${hours}:${minutes}:${seconds}`;
                                    } else {
                                        callAge = `${hours}:${minutes}:${seconds}`;
                                    }

                                    return (
                                        <TableRow key={deviceId + messageDttm}>
                                            <TableCell align="center">{utcDateTime}</TableCell>
                                            <TableCell align="center">{callAge}</TableCell>
                                            {showPoints && <TableCell align="center">{compressed_count}</TableCell>}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </ThemeProvider>
            </StyledEngineProvider>
        ) : null}
    </>;
}
